<template>
	<div class="text-align-center col-8-md col-offset-2-md pb-500-md pb-300-smo">
		<h2 class="overline mb-150" v-html="props.header.title" />
		<h3 class="heading-1 mb-100" v-html="props.header.heading" />
		<p v-for="(summary, summaryId) in props.header.summary" :key="summaryId" class="body-xl" v-html="summary"></p
	></div>
</template>

<script setup lang="ts">
import { LandingPageHeader } from 'types/layout';
interface Props {
	header: LandingPageHeader;
}

const props = defineProps<Props>();
</script>
